import {FormValues} from "../types";
import {getAxiosInstance} from "../../../../services/providers/api";
import {getErrorMessage} from "../../../../utils/getErrorMessage";

export default class RecebiveisService {
  getRecebiveis = async (
    page:number,
    pageSize:number,
    filter?:FormValues
  )=> {
    const selectedCompany: string | null = localStorage.getItem("selectedCompany");
    let parsedSelectedCompany = null;
    if (selectedCompany) parsedSelectedCompany = JSON.parse(selectedCompany);

    const paged = true;
    const forDownload = false;
    const merchantId = parsedSelectedCompany ? parsedSelectedCompany.merchantId : filter?.merchantId !== undefined && filter?.merchantId.length > 0 ? filter?.merchantId : null;
    const startDate = filter?.startDate || null;
    const finishDate = filter?.finishDate || null;
    const brand = filter?.brand || null;
    const acquirerNsu = filter?.acquirerNsu || null;
    const acquirer = filter?.acquirer !== -1 ? filter?.acquirer : null;
    const productName = filter?.productName || null;
    const isAdmin = filter?.isAdmin;
    const commercialHierId = filter?.commercialHierId !== -1 ? filter?.commercialHierId : null;
    const parcels = filter?.parcels !== -1 ? filter?.parcels : null;

    try {
      const response = await getAxiosInstance().get('/settlement-detail/get-settlement-receivables', {
        params: {
          offset: page,
          pageSize: pageSize,
          paged: paged,
          startDate: startDate,
          finishDate: finishDate,
          merchantId: merchantId,
          brand: brand,
          acquirerNsu: acquirerNsu,
          acquirer: acquirer,
          productName: productName,
          forDownload: forDownload,
          isAdmin: isAdmin,
          commercialHierId: commercialHierId,
          parcels: parcels
        }
      });

      return response.data.response;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
    }
  }

  downloadRecebiveisXls = async (
    page:number,
    pageSize:number,
    filter?:FormValues
  )=> {
    const selectedCompany: string | null = localStorage.getItem("selectedCompany");
    let parsedSelectedCompany = null;
    if (selectedCompany) parsedSelectedCompany = JSON.parse(selectedCompany);

    const paged = false;
    const forDownload = true;
    const merchantId = parsedSelectedCompany ? parsedSelectedCompany.merchantId : filter?.merchantId !== undefined && filter?.merchantId.length > 0 ? filter?.merchantId : null;
    const startDate = filter?.startDate || null;
    const finishDate = filter?.finishDate || null;
    const brand = filter?.brand || null;
    const acquirerNsu = filter?.acquirerNsu || null;
    const acquirer = filter?.acquirer !== -1 ? filter?.acquirer : null;
    const productName = filter?.productName || null;
    const isAdmin = filter?.isAdmin;

    try {
      const response = await getAxiosInstance().get('/settlement-detail/settlement-receivables-xls', {
        params: {
          offset: page,
          pageSize: pageSize,
          paged: paged,
          startDate: startDate,
          finishDate: finishDate,
          merchantId: merchantId,
          brand: brand,
          acquirerNsu: acquirerNsu,
          acquirer: acquirer,
          productName: productName,
          forDownload: forDownload,
          isAdmin: isAdmin
        },
        responseType: 'blob'
      });

      return response.data;
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      console.log(errorMessage);
    }
  }
}
